<template>
  <div>
    <div class="ai-diff text-body-2 pa-3 rounded">
      <template v-if="segments">
        <template v-for="(segment, index) in shown" :key="index">
          <ins v-if="segment.type === 'added'" class="ai-diff__added">{{
            segment.text
          }}</ins>
          <template v-else>{{ segment.text }}</template>
        </template>
      </template>
      <template v-else>{{ rewrite }}</template>
    </div>

    <div v-if="changed" class="text-caption text-medium-emphasis mt-1">
      <ins class="ai-diff__added">Groen</ins> = nieuw of aangepast ten opzichte
      van je eigen tekst.
    </div>
    <div v-else-if="!segments" class="text-caption text-medium-emphasis mt-1">
      Deze tekst is te lang om de wijzigingen te markeren.
    </div>
  </div>
</template>

<script setup>
/**
 * A suggested rewrite with what is new or changed against the original highlighted.
 * What was removed is not shown: the text reads exactly as it will be.
 */
import { computed } from "vue";
import { diffWords, visibleSegments } from "@/utils/textDiff";

const props = defineProps({
  original: { type: String, default: "" },
  rewrite: { type: String, default: "" },
});

const segments = computed(() => diffWords(props.original, props.rewrite));
// Only what the rewrite contains; something to mark means something was added.
const shown = computed(() =>
  visibleSegments(segments.value, { showRemoved: false }),
);
const changed = computed(() =>
  shown.value.some((segment) => segment.type === "added"),
);
</script>

<style scoped>
.ai-diff {
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  background-color: rgba(var(--v-theme-on-surface), 0.05);
}

/* Not colour alone: additions are underlined as well. */
.ai-diff__added {
  background-color: rgba(var(--v-theme-success), 0.22);
  text-decoration: underline;
  text-decoration-color: rgba(var(--v-theme-success), 0.9);
  text-underline-offset: 2px;
  border-radius: 2px;
}
</style>
